import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';

class StockMessaging extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateStockMessaging);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateStockMessaging);
  }

  /**
   * Updates the stock messaging when variant changes.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateStockMessaging = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newStockMessaging = event.detail.data.html.querySelector('stock-messaging');

    if (!newStockMessaging) return;

    morph(this, newStockMessaging, { childrenOnly: true });
  };
}

if (!customElements.get('stock-messaging')) {
  customElements.define('stock-messaging', StockMessaging);
}

